var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Health Information"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Current Medical Status"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("div", { staticClass: "mb-2" }, [_vm._v("Medical Conditions")]),
          _c("ul", { staticClass: "list-disc pl-5 space-y-1" }, [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.data.medical_conditions
                    ? _vm.data.medical_conditions
                    : "N/A"
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Past Conditions")]),
          _c("ul", { staticClass: "list-disc pl-5 space-y-1" }, [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.data.past_conditions ? _vm.data.past_conditions : "N/A"
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Medications"),
        ]),
        _c(
          "div",
          { staticClass: "flex-2 text-16 font-medium text-gray-400" },
          [
            _c("div", { staticClass: "mb-2" }, [_vm._v("Current Medications")]),
            _vm._l(_vm.data.client_medications, function (med, index) {
              return _c("div", { key: index, staticClass: "mb-4" }, [
                _c("ul", { staticClass: "list-disc pl-5 space-y-1" }, [
                  _c("li", [
                    _vm._v("Name: " + _vm._s(med.name ? med.name : "N/A")),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Dosage: " + _vm._s(med.dosage ? med.dosage : "N/A")
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Frequency: " +
                        _vm._s(med.frequency ? med.frequency : "N/A")
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Medication File Attached: " +
                        _vm._s(med.file ? med.file : "N/A")
                    ),
                  ]),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Allergies"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("div", { staticClass: "mb-2" }, [_vm._v("Food")]),
          _c(
            "ul",
            { staticClass: "list-disc pl-5 space-y-1" },
            _vm._l(_vm.data.allergies_food, function (allergy) {
              return _c("li", { key: allergy }, [
                _vm._v(_vm._s(allergy ? allergy : "N/A")),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Medication")]),
          _c(
            "ul",
            { staticClass: "list-disc pl-5 space-y-1" },
            _vm._l(_vm.data.allergies_medication, function (allergy) {
              return _c("li", { key: allergy }, [
                _vm._v(_vm._s(allergy ? allergy : "N/A")),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Environmental")]),
          _c(
            "ul",
            { staticClass: "list-disc pl-5 space-y-1" },
            _vm._l(_vm.data.allergies_environmental, function (allergy) {
              return _c("li", { key: allergy }, [
                _vm._v(_vm._s(allergy ? allergy : "N/A")),
              ])
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("DNR (Do Not Resuscitate)"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("ul", { staticClass: "list-disc pl-5 space-y-1" }, [
            _c("li", { staticClass: "capitalize" }, [
              _vm._v(
                "DNR Order: " +
                  _vm._s(_vm.data.dnr_order ? _vm.data.dnr_order : "N/A")
              ),
            ]),
            _c("li", { staticClass: "capitalize" }, [
              _vm._v(
                "Copy Attached: " +
                  _vm._s(
                    _vm.data.dnr_copy_attached
                      ? _vm.data.dnr_copy_attached
                      : "N/A"
                  )
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }